import React from "react";
import Common_Back_Btn from "../../../common_components/common_back_btn/Common_Back_Btn";
import { faLeftRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun } from "@fortawesome/free-regular-svg-icons";
import { Table } from "react-bootstrap";
import { formatDate } from "../../../../utils/common";

function CoinsTransactions({ WalletHistory, pointSetup }) {
  const getExpiryDate = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return formatDate(d);
  };

  const checkRewardStatus = (createdAt, days) => {
    const createdDate = new Date(createdAt);
    const expiryDate = new Date(createdDate);
    expiryDate.setDate(createdDate.getDate() + days);

    const today = new Date();

    return today > expiryDate ? "invalid" : "valid";
  };
  return (
    <>
      <section className="My_rewards_container">
        {/* Back */}
        <Common_Back_Btn backText={"Back"} />

        {/* Reward Information */}
        <div className="My_rewards_info_box">
          {/* Recent Transactions */}
          <div className="My_rewards_recent">
            <div className="My_rewards_info_heading">
              <span className="My_rewards_recent_icon">
                <FontAwesomeIcon icon={faLeftRight} />
              </span>
              Coins Transactions
            </div>

            <div className="My_rewards_table_wrapper">
              <Table bordered responsive className="My_rewards_table">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Remark</th>
                    <th>Action</th>
                    <th>Coins</th>
                    <th>Earning Date</th>
                    <th>Expiration Date</th>
                    {/* <th>Status</th> */}
                  </tr>
                </thead>

                <tbody>
                  {WalletHistory && WalletHistory.length > 0 ? (
                    WalletHistory.map((val, index) => {
                      const status = checkRewardStatus(
                        val?.createdAt,
                        Number(pointSetup?.expired_days) || 0,
                      );

                      return (
                        <tr key={val?.id || index}>
                          <td>{index + 1}</td>
                          <td>{val?.remark}</td>
                          <td>{val?.type}</td>
                          <td>{val?.coin} Coins</td>
                          <td>{formatDate(val?.createdAt)}</td>

                          <td>
                            {getExpiryDate(
                              val?.createdAt,
                              Number(pointSetup?.expired_days) || 0,
                            )}
                          </td>

                          {/* <td>
                            <span className={`My_rewards_status ${status}`}>
                              {status === "valid" ? "Valid" : "Invalid"}
                            </span>
                          </td> */}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center" }}>
                        No Transaction Found!
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CoinsTransactions;
